export default __webpack_public_path__ + "static/media/logo-spfilm-comission-negativo.4275e394.png";